import React from 'react';
import '../style/Teaching.scss';
// react bootstrap
import { Container } from 'react-bootstrap';
import Header from '../components/public/Header';

function Teaching3() {
  return (
    <>
      <Header />
      <Container>
        <div className='content'>
          <h3 className='text-left text-secondary'>如何運行明點</h3>
          <p className='chineseParagraph'>
            明點存在身體微細脈絡系統中流動,除此之外還有四種終生保持不動的微細明點,這就是分別位於眉間輪、喉輪、心輪、臍輪的身明點、語明點、意明點及智慧明點。這些明點相較於與光明心不異的「最細明點」還要粗，在人進入「死有」或證得「佛果」之中就不存在了。
            當我們處於醒時、夢時、無夢深層睡眠時或生貪時,業風便會隨著這些經驗分別攝集於身明點、語明點、意明點及智慧明點的附近,而不是存在於中脈內。此時心識所生起的顯相為虛妄不實,因為它們是受業風所感召的業惑煩惱影響而產生。
            若行者能令光明心轉為不變樂空智慧，便能斷除業風及去除業風所染的障垢。因此,實有顯相、錯亂語,無明意、有漏貪樂便不再出現。
          </p>
        </div>
      </Container>
    </>
  );
}

export default Teaching3;
